var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPause48Filled = function SvgIconPause48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 11.3h-2.6a2.9 2.9 0 0 0-2.9 2.9v19.6a2.9 2.9 0 0 0 2.9 2.9h2.6a2.9 2.9 0 0 0 2.9-2.9V14.2a2.9 2.9 0 0 0-2.9-2.9ZM32.8 11.3h-2.6a2.9 2.9 0 0 0-2.9 2.9v19.6a2.9 2.9 0 0 0 2.9 2.9h2.6a2.9 2.9 0 0 0 2.9-2.9V14.2a2.9 2.9 0 0 0-2.9-2.9Z",
    fill: "current"
  })));
};
export default SvgIconPause48Filled;